import { Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ThicknessInspectionReportType } from '../../viewmodels/reports/thickness-reports/thickness-report';

@Pipe({
  name: 'thicknessReportType',
})
export class ThicknessReportTypePipe implements PipeTransform {

  constructor(private i18NextPipe: I18NextPipe ) {
  }

  transform(value: ThicknessInspectionReportType, args?: any): any {
    switch (value) {
      case ThicknessInspectionReportType.EddyCurrent:
        return this.i18NextPipe.transform('ThicknessReportTypePipe.EddyCurrent');
      case ThicknessInspectionReportType.Iris:
        return this.i18NextPipe.transform('ThicknessReportTypePipe.Iris');
      case ThicknessInspectionReportType.Rt:
        return this.i18NextPipe.transform('ThicknessReportTypePipe.Rt');
      case ThicknessInspectionReportType.Ut:
        return this.i18NextPipe.transform('ThicknessReportTypePipe.Ut');
    }
  }

}
